export default __webpack_public_path__ + "static/media/banner-brand.bd4c1d96.png";